// src/components/ProtectedRoute/ProtectedRoute.js

import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { UserContext } from "../../contexts/UserContext";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useContext(UserContext);
  
   if (loading) {
    // You can render a spinner or null while checking localStorage
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/" />;
  }

  return children;
};

export default ProtectedRoute;


// import React from "react";
// import { Navigate } from "react-router-dom";

// const ProtectedRoute = ({ user, children }) => {
//   if (!user) return <Navigate to="/" />;
//   return children;
// };

// export default ProtectedRoute;
